var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "JumpTemplate" },
    [
      _c("div", { staticClass: "JumpTLeft", style: _vm.myIframeStyle }, [
        _c(
          "div",
          { ref: "topIframe", staticClass: "topIframe", style: _vm.topIframe },
          [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.iframeDrag,
                  expression: "iframeDrag"
                }
              ],
              staticClass: "iframe_mask"
            }),
            _vm._v(" "),
            _vm.topIframeUrl
              ? _c("iframe", {
                  key: _vm.topIframeUrl,
                  attrs: {
                    id: "iframe",
                    width: "100%",
                    height: "100%",
                    src: _vm.topIframeUrl,
                    frameborder: "0"
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bottomIframeUrl,
              expression: "bottomIframeUrl"
            }
          ],
          staticClass: "iframeDrapLineTB",
          on: {
            mousedown: function($event) {
              $event.stopPropagation()
              return _vm.iframeLineMoveTB($event)
            }
          }
        }),
        _vm._v(" "),
        _vm.bottomIframeUrl
          ? _c(
              "div",
              { staticClass: "bottomIframe" },
              [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.iframeDrag,
                      expression: "iframeDrag"
                    }
                  ],
                  staticClass: "iframe_mask"
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "closeChildrenIframe",
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.answerBoardThreeScreen()
                      }
                    }
                  },
                  [_vm._v("关闭\n      ")]
                ),
                _vm._v(" "),
                _c("iframe", {
                  attrs: {
                    width: "100%",
                    height: "100%",
                    src: _vm.bottomIframeUrl,
                    frameborder: "0"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "JumpTRight" }),
      _vm._v(" "),
      _vm.isSmall
        ? _c(
            "div",
            {
              directives: [{ name: "drag", rawName: "v-drag" }],
              ref: "dragIcon",
              staticClass: "dragIcon",
              style: _vm.dragIconStyle
            },
            [_c("i", { staticClass: "el-icon-copy-document" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "newDialogDrag", rawName: "v-newDialogDrag" }],
          staticClass: "courseSubDialog2",
          class: _vm.arrow ? "courseSubDialog" : "",
          attrs: {
            "close-on-click-modal": false,
            modal: false,
            visible: _vm.dialogVisible,
            "show-close": false,
            customClass: "customHeight2"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dia_span",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "bury",
                      rawName: "v-bury",
                      value: { route: _vm.$route, template: _vm.activeOne },
                      expression: "{ route: $route, template: activeOne }"
                    }
                  ],
                  attrs: { size: "mini" },
                  on: { click: _vm.back }
                },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.RPAPlatform == "RPAOS" || _vm.RPAPlatform == "RPAOSV3"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "da_icon",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.threeScreenIframe }
                        },
                        [_vm._v("启动RPA")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isBtn
                    ? _c(
                        "el-button",
                        {
                          staticClass: "da_icon",
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: _vm.handleRefresh,
                            dblclick: _vm.dblclick
                          }
                        },
                        [_vm._v("任务提交")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dia_div" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.courseName))
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "operations_button" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#215DE8", "font-weight": "normal" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        _vm.ckdaShow = true
                      }
                    }
                  },
                  [_vm._v("查看答案")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.questionEnclosure.length,
                        expression: "questionEnclosure.length"
                      }
                    ],
                    staticStyle: { color: "#215DE8", "font-weight": "normal" },
                    attrs: { type: "text" },
                    on: { click: _vm.fjhandleClick }
                  },
                  [_vm._v("附件")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.activeOne.resourceType == 7 || _vm.activeOne.resourceType == 3
            ? _c("div", {
                staticClass: "editorShowArea",
                staticStyle: { "user-select": "text" },
                domProps: { innerHTML: _vm._s(_vm.activeOne.content) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "operations_foot" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.layoutChange },
                  model: {
                    value: _vm.diaLayout,
                    callback: function($$v) {
                      _vm.diaLayout = $$v
                    },
                    expression: "diaLayout"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "浮窗" } }),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "左右" } }),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "全屏" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { color: "#215DE8", "font-weight": "normal" },
                  attrs: { type: "text" },
                  on: { click: _vm.showFeedBack, dblclick: _vm.dblclick }
                },
                [_vm._v("意见反馈")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.diaLayout == "左右",
              expression: "diaLayout == '左右'"
            }
          ],
          staticClass: "button_goback"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.arrow,
                  expression: "arrow"
                }
              ],
              staticClass: "goback_left",
              style: { right: _vm.arrowLeft + "px" },
              on: {
                click: function($event) {
                  return _vm.arrowChang(1)
                }
              }
            },
            [_vm._m(0)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.arrow,
                  expression: "!arrow"
                }
              ],
              staticClass: "goback_right",
              on: {
                click: function($event) {
                  return _vm.arrowChang(2)
                }
              }
            },
            [_vm._m(1)]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "count_down_dialog",
          attrs: {
            top: "38vh",
            width: "422px",
            title: "提示",
            "destroy-on-close": "",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _vm.isShowTeamWeight()
            ? _c(
                "div",
                { staticClass: "count_down_main" },
                [
                  _vm.teamWeight >= 0
                    ? [
                        _c("p", [_vm._v("本题总分:10")]),
                        _vm._v(" "),
                        Number(_vm.type) === 3
                          ? _c("p", [
                              _vm._v(
                                "本题本岗位总分:" +
                                  _vm._s(Number(_vm.rolesWeight))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        Number(_vm.type) === 3
                          ? _c("p", [
                              _vm._v(
                                "本岗位得分:" + _vm._s(Number(_vm.teamWeight))
                              )
                            ])
                          : _c("p", [
                              _vm._v(
                                "本题得分:" + _vm._s(Number(_vm.teamWeight))
                              )
                            ])
                      ]
                    : Number(_vm.type) === 3 && _vm.teamWeight == -2
                    ? _c("div", { staticClass: "teamWeightMsg" }, [
                        _vm._v("\n        本任务对当前岗位不做考核\n      ")
                      ])
                    : _vm.teamWeight == -3
                    ? _c("div", { staticClass: "teamWeightMsg" }, [
                        _vm._v("\n        资源加载中，请稍后再试。\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "teamWeightMsg" }, [
                    _vm._v("\n        任务提交成功！\n      ")
                  ])
                ],
                2
              )
            : _c("div", { staticClass: "teamWeightMsg" }, [
                _vm._v("\n      任务提交成功！\n    ")
              ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.back } },
                [_vm._v("返回上一页")]
              ),
              _vm._v(" "),
              _vm.isMyStatus
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.nextQuestions("next")
                        }
                      }
                    },
                    [_vm._v("下一题")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v("留在此页")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "feed_back",
          attrs: {
            title: "意见反馈",
            visible: _vm.feedBackShow,
            width: "650px",
            center: "",
            "custom-class": "feedBack",
            modal: false,
            "destroy-on-close": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.feedBackShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "from_cont" },
            [
              _c(
                "el-form",
                {
                  ref: "feedForm",
                  attrs: {
                    inline: "",
                    model: _vm.feedForm,
                    rules: _vm.feedRules,
                    "label-position": "left",
                    "label-width": "100%"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题类型", prop: "questionType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.feedForm.questionType,
                            callback: function($$v) {
                              _vm.$set(_vm.feedForm, "questionType", $$v)
                            },
                            expression: "feedForm.questionType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "试题评分" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "业务系统" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "教学平台" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "产品建议" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "其他" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.feedForm.questionType == "试题评分"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "试题编号", prop: "questionCode" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "20" },
                            model: {
                              value: _vm.feedForm.questionCode,
                              callback: function($$v) {
                                _vm.$set(_vm.feedForm, "questionCode", $$v)
                              },
                              expression: "feedForm.questionCode"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("（例如：TY-SS-0703）")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题描述", prop: "questionDescribe" } },
                    [
                      _c("editor", {
                        model: {
                          value: _vm.feedForm.questionDescribe,
                          callback: function($$v) {
                            _vm.$set(_vm.feedForm, "questionDescribe", $$v)
                          },
                          expression: "feedForm.questionDescribe"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  staticClass: "zl_button zl_whiteButton",
                  on: {
                    click: function($event) {
                      return _vm.handleFeedBack(false, "feedForm")
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "zl_button zl_blueButton",
                  on: {
                    click: function($event) {
                      return _vm.handleFeedBack(true, "feedForm")
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "feed_back",
          attrs: {
            title: "意见反馈",
            visible: _vm.feedBackCloseShow,
            width: "580px",
            center: "",
            "custom-class": "feedBack",
            modal: false,
            "close-on-click-modal": false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.feedBackCloseShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "close_cont" }, [
            _c("div", { staticClass: "title" }, [
              _c("p", [_vm._v("提交成功")]),
              _vm._v(" "),
              _c("p", [_vm._v("感谢您的反馈，我们会尽快解决您的问题")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  staticClass: "zl_button zl_whiteButton",
                  on: {
                    click: function($event) {
                      _vm.feedBackCloseShow = false
                    }
                  }
                },
                [_vm._v("关 闭")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ckdaShow,
              expression: "ckdaShow"
            }
          ],
          staticClass: "da_back"
        },
        [
          _c(
            "p",
            [
              _vm._v(" " + _vm._s(_vm.courseName) + " "),
              _c("el-button", {
                attrs: { size: "mini", icon: "el-icon-close", circle: "" },
                on: {
                  click: function($event) {
                    _vm.ckdaShow = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 48px)" } },
            [
              _c("my-component", {
                attrs: {
                  companyCode: _vm.templateCode,
                  isShow:
                    _vm.userType == 0 ||
                    _vm.userType == 1 ||
                    (_vm.isBtn && !!_vm.activeOne.show) ||
                    _vm.scoreType === "dev",
                  optObject: _vm.optObject,
                  refresh: _vm.answerRefresh,
                  catalogId: _vm.catalogId,
                  courseType: _vm.courseType,
                  type: _vm.type,
                  myId: _vm.activeOne.id
                },
                on: { taskSubmit: _vm.taskSubmit }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "fj_back",
          attrs: {
            "append-to-body": true,
            "show-close": false,
            "close-on-click-modal": false,
            center: "",
            "custom-class": "fjBack",
            "destroy-on-close": "",
            visible: _vm.fjShow,
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              _vm.fjShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "fj_left" }, [
            _c("iframe", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { src: _vm.filePreviewUrl, frameborder: "0" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fj_right" }, [
            _c(
              "div",
              { staticClass: "fj_title" },
              [
                _c("span", [_vm._v("附件")]),
                _vm._v(" "),
                _c("el-button", {
                  attrs: { size: "mini", icon: "el-icon-close", circle: "" },
                  on: { click: _vm.fjhandleClose }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "enclosureUl" },
              _vm._l(_vm.questionEnclosure, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "questionEnclosureItem",
                    class: { active: _vm.fjactiveIndex == index },
                    on: {
                      click: function($event) {
                        return _vm.handlePreview(item.newAttaUrl, index)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "enclosurePopoverLabel",
                        attrs: { title: item.name }
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isShow
        ? _c("iframe", {
            ref: "excelIframe",
            staticClass: "RPAiframe",
            attrs: {
              id: "RPAiframe",
              width: _vm.RPAStyle.width,
              height: _vm.RPAStyle.height,
              src: _vm.iframeAddress,
              frameborder: "0"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "arrow_left" }, [
      _c("img", {
        attrs: {
          src: require("../views/training2/class/img/chevron-right.double2.png")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "arrow_right" }, [
      _c("img", {
        attrs: {
          src: require("../views/training2/class/img/chevron-left.double1.png")
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-541a816a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541a816a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JumpTemplate2.vue
// module id = null
// module chunks = 